import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useRef } from "react";
import { addDoc, collection, doc, getDoc, getDocs } from "firebase/firestore";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";
import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { db, storage } from "../Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";
import { gerarSequencial } from "../Utils/sequencial";
import { compressImage } from "../../utils/compressImage";
import { atualizarDocumentoComMesclagem } from "../Utils/concorrenciaFirestore";
import RelatorioCaracterizacaoMiudoPrint, { ChartGranulometria } from "./relatoriocaracterizacaoMiudoPrint";
import RelatorioCaracterizacaoResumoPrint from "../Relatorios/RelatorioCaracterizacaoPrint";
import "./relatoriocaracterizacaoMiudoPrint.css";

const peneirasPadrao = ["9,5", "6,3", "4,8", "2,36", "1,18", "0,60", "0,30", "0,15", "Fundo"];

const granulometriaModelo = peneirasPadrao.map((peneira) => ({ peneira }));

const faixas = [
  ["0", "0", "0", "0"],
  ["0", "0", "0", "7"],
  ["0", "0", "5", "10"],
  ["0", "10", "20", "25"],
  ["5", "20", "30", "50"],
  ["15", "35", "55", "70"],
  ["50", "65", "85", "95"],
  ["85", "90", "95", "100"],
  ["100", "100", "100", "100"],
];

const zonas = ["Zona", "Zona", "Zona", "Zona"];
const toleranciasModuloFinura = ["1,55", "2,20", "2,90", "3,50"];

const densidadeInicial = {
  materialSss1: "",
  materialSss2: "",
  frascoMaterial1: "",
  frascoMaterial2: "",
  frascoAgua1: "",
  frascoAgua2: "",
  pesoImerso1: "",
  pesoImerso2: "",
  volumeSss1: "",
  volumeSss2: "",
  volumeSeco1: "",
  volumeSeco2: "",
  materialSeco1: "",
  materialSeco2: "",
  densidadeSss1: "",
  densidadeSss2: "",
  densidadeSeco1: "",
  densidadeSeco2: "",
  densidadeMedia: "",
  absorcao1: "",
  absorcao2: "",
};

const massaUnitariaInicial = {
  volume1: "",
  volume2: "",
  recipienteVazio1: "",
  recipienteVazio2: "",
  recipienteAgregado1: "",
  recipienteAgregado2: "",
  massaAgregado1: "",
  massaAgregado2: "",
  massaUnitaria1: "",
  massaUnitaria2: "",
  mediaMassaUnitaria: "",
};

const torroesPulverulentosInicial = {
  torroesAntes: "",
  torroesDepois: "",
  torroesPercentual: "",
  pulverulentosAntes: "",
  pulverulentosDepois: "",
  pulverulentosPercentual: "",
};

const impurezasOrganicasInicial = {
  data: "",
  clarezaMaisClara: false,
  relacaoIgual: false,
  padraoMaisEscura: false,
};

const equivalenteAreiaInicial = {
  data: "",
  ensaios: Array.from({ length: 3 }, () => ({
    alfa: "",
    beta: "",
    resultado: "",
  })),
  media: "",
  fotoAntes: null,
  fotoDepois: null,
};

const particulasLevesInicial = {
  data: "",
  teor: "",
  massaEspecificaSolucao: "2,00",
};

const saisCloretosSulfatosInicial = {
  data: "",
  teorCloretos: "",
  teorSulfatos: "",
  teorSais: "",
  observacao: "Realizado em laboratório parceiro",
};

const normaReferenciaInicial = {
  granulometria: "NBR 17054/2022 - Determinação da Composição Granulométrica",
  densidade: "NBR NM 16917/2021 - Agregado Miúdo - Determinação da densidade e da absorção de água",
  massaUnitaria: "NBR 16972/2021 - Determinação da massa unitária e do índice de vazios",
  torroesArgila: "NBR 7218/2025 - Determinação do teor de argila em torrões e materiais friáveis",
  materialPulverulento: "NBR 16973/2021 - Determinação do material fino que passa pela peneira de 75 µm por lavagem",
  impurezasOrganicas: "NBR NM 49/2001 - Agregado miúdo - Determinação de impurezas orgânicas",
  equivalenteAreia: "ABNT NBR 12052 - Solo ou agregado miúdo - Determinação do equivalente de areia",
  particulasLeves: "ABNT NBR 7211/2022 - Teor de Partículas Leves (Matérias Carbonosos)",
  saisCloretosSulfatos: "Determinação de Sais, Cloretos (Cl-) e Sulfatos Solúveis (SO42-)",
};

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function pareceAgregadoGraudo(dados) {
  const descricao = `${dados?.amostra || ""} ${dados?.descricao || ""} ${dados?.tipoMaterial || ""}`
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  return /\b(brita|graudo|pedrisco)\b/.test(descricao);
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const n = Number(String(valor).replace(".", "").replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function numeroBR(valor, casas = 1) {
  if (valor === "" || valor === null || valor === undefined) return "";
  const n = typeof valor === "number" ? valor : numero(valor);
  if (n === null) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function recalcularEquivalenteAreia(dados = {}) {
  const ensaiosOriginais = Array.isArray(dados.ensaios) ? dados.ensaios : [];
  const ensaios = Array.from({ length: 3 }, (_, index) => {
    const ensaio = ensaiosOriginais[index] || {};
    const alfa = numero(ensaio.alfa);
    const beta = numero(ensaio.beta);
    const resultado = alfa !== null && beta ? (alfa / beta) * 100 : null;

    return {
      ...ensaio,
      alfa: ensaio.alfa ?? "",
      beta: ensaio.beta ?? "",
      resultado: resultado !== null ? numeroBR(resultado, 1) : "",
    };
  });
  const resultados = ensaios.map((ensaio) => numero(ensaio.resultado)).filter((valor) => valor !== null);
  const media = resultados.length
    ? resultados.reduce((soma, valor) => soma + valor, 0) / resultados.length
    : null;

  return {
    ...equivalenteAreiaInicial,
    ...dados,
    ensaios,
    media: media !== null ? numeroBR(media, 1) : "",
  };
}

function valorPreenchido(valor) {
  if (valor === null || valor === undefined || valor === false) return false;
  return String(valor).trim() !== "";
}

function algumCampoPreenchido(objeto = {}, campos = [], valoresPadrao = {}) {
  return campos.some((campo) => {
    const valor = objeto[campo];
    if (
      Object.prototype.hasOwnProperty.call(valoresPadrao, campo) &&
      String(valor ?? "").trim() === String(valoresPadrao[campo]).trim()
    ) {
      return false;
    }
    return valorPreenchido(valor);
  });
}

function possuiGranulometriaPreenchida(dados) {
  return (
    valorPreenchido(dados.massaInicialA) ||
    valorPreenchido(dados.massaInicialB) ||
    (dados.granulometria || []).some((linha) =>
      ["massaA", "massaB", "retidaA", "retidaB", "acumulada"].some((campo) =>
        valorPreenchido(linha?.[campo])
      )
    )
  );
}

function ensaiosComDataPendente(dados) {
  const pendentes = [];

  if (possuiGranulometriaPreenchida(dados) && !valorPreenchido(dados.dataGranulometria)) {
    pendentes.push("granulometria");
  }
  if (algumCampoPreenchido(dados.densidade, Object.keys(densidadeInicial)) && !valorPreenchido(dados.dataDensidade)) {
    pendentes.push("densidade");
  }
  if (algumCampoPreenchido(dados.massaUnitaria, Object.keys(massaUnitariaInicial)) && !valorPreenchido(dados.dataMassaUnitaria)) {
    pendentes.push("massa unitária");
  }
  if (
    algumCampoPreenchido(dados.torroesPulverulentos, ["torroesAntes", "torroesDepois", "torroesPercentual"]) &&
    !valorPreenchido(dados.dataTorroesArgila)
  ) {
    pendentes.push("argila em torrões");
  }
  if (
    algumCampoPreenchido(dados.torroesPulverulentos, ["pulverulentosAntes", "pulverulentosDepois", "pulverulentosPercentual"]) &&
    !valorPreenchido(dados.dataMateriaisPulverulentos)
  ) {
    pendentes.push("material pulverulento");
  }
  if (
    algumCampoPreenchido(dados.impurezasOrganicas, ["clarezaMaisClara", "relacaoIgual", "padraoMaisEscura"]) &&
    !valorPreenchido(dados.impurezasOrganicas?.data)
  ) {
    pendentes.push("impurezas orgânicas");
  }
  if (
    (dados.equivalenteAreia?.ensaios || []).some((ensaio) =>
      valorPreenchido(ensaio.alfa) || valorPreenchido(ensaio.beta)
    ) &&
    !valorPreenchido(dados.equivalenteAreia?.data)
  ) {
    pendentes.push("equivalente de areia");
  }
  if (
    algumCampoPreenchido(
      dados.particulasLeves,
      ["teor", "massaEspecificaSolucao"],
      { massaEspecificaSolucao: particulasLevesInicial.massaEspecificaSolucao }
    ) &&
    !valorPreenchido(dados.particulasLeves?.data)
  ) {
    pendentes.push("partículas leves");
  }
  if (
    algumCampoPreenchido(dados.saisCloretosSulfatos, ["teorCloretos", "teorSulfatos", "teorSais"]) &&
    !valorPreenchido(dados.saisCloretosSulfatos?.data)
  ) {
    pendentes.push("sais, cloretos e sulfatos");
  }

  return pendentes;
}

function recalcularGranulometria(dados) {
  const massaInicialA = numero(dados.massaInicialA);
  const massaInicialB = numero(dados.massaInicialB);
  const possuiGranulometria = (dados.granulometria || []).some(
  (linha) =>
    numero(linha.massaA) !== null ||
    numero(linha.massaB) !== null
);
  let acumulada = 0;
  const acumuladasCalculadas = new Map();

  const granulometria = (dados.granulometria || []).map((linha) => {
    const massaA = numero(linha.massaA);
    const massaB = numero(linha.massaB);
    const retidaA =
      massaA !== null && massaInicialA ? (massaA / massaInicialA) * 100 : null;
    const retidaB =
      massaB !== null && massaInicialB ? (massaB / massaInicialB) * 100 : null;
    const valoresRetidos = [retidaA, retidaB].filter((valor) => valor !== null);
    const media =
      valoresRetidos.length > 0
        ? valoresRetidos.reduce((total, valor) => total + valor, 0) / valoresRetidos.length
        : null;
    const variacao =
      retidaA !== null && retidaB !== null ? Math.abs(retidaA - retidaB) : null;

    if (media !== null) acumulada += media;
    if (media !== null) acumuladasCalculadas.set(String(linha.peneira || ""), acumulada);

    return {
      ...linha,
      retidaA: retidaA !== null ? numeroBR(retidaA, 1) : "",
      retidaB: retidaB !== null ? numeroBR(retidaB, 1) : "",
      variacao: variacao !== null ? numeroBR(variacao, 2) : "",
      media: media !== null ? numeroBR(media, 1) : "",
      acumulada: media !== null ? numeroBR(acumulada, 1) : "",
    };
  });

  const moduloFinura = possuiGranulometria
  ? calcularModuloFinuraMiudo(granulometria, acumuladasCalculadas)
  : "";
  const massasA = granulometria.map((linha) => numero(linha.massaA)).filter((valor) => valor !== null);
  const massasB = granulometria.map((linha) => numero(linha.massaB)).filter((valor) => valor !== null);
  const totalMassaANum = massasA.length
    ? massasA.reduce((total, valor) => total + valor, 0)
    : null;
  const totalMassaBNum = massasB.length
    ? massasB.reduce((total, valor) => total + valor, 0)
    : null;
  const diferencaMassaA =
    totalMassaANum !== null && massaInicialA ? ((massaInicialA - totalMassaANum) / massaInicialA) * 100 : null;
  const diferencaMassaB =
    totalMassaBNum !== null && massaInicialB ? ((massaInicialB - totalMassaBNum) / massaInicialB) * 100 : null;
  const diametroMaximo = possuiGranulometria
  ? calcularDiametroMaximo(granulometria)
  : "";

  return {
    ...dados,
    granulometria,
    moduloFinura,
    totalMassaA: totalMassaANum !== null ? numeroBR(totalMassaANum, 1) : "",
    totalMassaB: totalMassaBNum !== null ? numeroBR(totalMassaBNum, 1) : "",
    diferencaMassaA: diferencaMassaA !== null ? numeroBR(diferencaMassaA, 2) : "",
    diferencaMassaB: diferencaMassaB !== null ? numeroBR(diferencaMassaB, 2) : "",
    diferencaMaxima: diametroMaximo,
    diametroMaximo,
    tolerancias: toleranciasModuloFinura.join("  "),
  };
}

function calcularDiametroMaximo(granulometria) {
  const indiceFundo = granulometria.findIndex((linha) => String(linha.peneira || "").toLowerCase() === "fundo");
  const linhas = indiceFundo >= 0 ? granulometria.slice(0, indiceFundo) : granulometria;

  for (let index = 1; index < linhas.length; index += 1) {
    const acumulada = numero(linhas[index].acumulada);
    if (acumulada !== null && acumulada > 5) {
      return `${formatarDiametroMaximo(linhas[index - 1]?.peneira)} mm`;
    }
  }

  return "";
}

function formatarDiametroMaximo(peneira) {
  const valor = numero(peneira);
  if (valor === null) return peneira || "";

  return valor.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

function calcularModuloFinuraMiudo(granulometria, acumuladasCalculadas = new Map()) {
  const ultimaPeneira = granulometria.find((linha) => String(linha.peneira || "") === "0,15");
  if (!acumuladasCalculadas.has("0,15") && numero(ultimaPeneira?.acumulada) === null) return "";

  const peneirasModuloFinura = new Set(["9,5", "4,8", "2,36", "1,18", "0,60", "0,30", "0,15"]);
  let acumuladaAnterior = null;
  const somaAcumuladas = granulometria.reduce((total, linha) => {
    const peneira = String(linha.peneira || "");
    const acumuladaAtual = acumuladasCalculadas.has(peneira)
      ? acumuladasCalculadas.get(peneira)
      : numero(linha.acumulada);
    if (acumuladaAtual !== null) acumuladaAnterior = acumuladaAtual;

    if (!peneirasModuloFinura.has(peneira)) return total;
    return total + (acumuladaAtual ?? acumuladaAnterior ?? 0);
  }, 0);

  return numeroBR(somaAcumuladas / 100, 2);
}

function recalcularDensidade(densidade) {
  const calcularEnsaio = (sufixo) => {
    const materialSss = numero(densidade[`materialSss${sufixo}`]);
    const frascoMaterial = numero(densidade[`frascoMaterial${sufixo}`]);
    const frascoAgua = numero(densidade[`frascoAgua${sufixo}`]);
    const materialSeco = numero(densidade[`materialSeco${sufixo}`]);
    const pesoImerso =
      frascoMaterial !== null && frascoAgua !== null ? frascoMaterial - frascoAgua : null;
    const volumeSss =
      materialSss !== null && pesoImerso !== null ? materialSss - pesoImerso : null;
    const volumeSeco =
      materialSeco !== null && pesoImerso !== null ? materialSeco - pesoImerso : null;

    return {
      [`pesoImerso${sufixo}`]: pesoImerso !== null ? numeroBR(pesoImerso, 1) : "",
      [`volumeSss${sufixo}`]: volumeSss !== null ? numeroBR(volumeSss, 1) : "",
      [`volumeSeco${sufixo}`]: volumeSeco !== null ? numeroBR(volumeSeco, 1) : "",
      [`densidadeSss${sufixo}`]:
        materialSss !== null && volumeSss ? numeroBR(materialSss / volumeSss, 3) : "",
      [`densidadeSeco${sufixo}`]:
        materialSeco !== null && volumeSss ? numeroBR(materialSeco / volumeSss, 3) : "",
      [`absorcao${sufixo}`]:
        materialSss !== null && materialSeco
          ? numeroBR(((materialSss - materialSeco) / materialSeco) * 100, 2)
          : "",
    };
  };

  const ensaio1 = calcularEnsaio("1");
  const ensaio2 = calcularEnsaio("2");
  const densidadeSss1 = numero(ensaio1.densidadeSss1);
  const densidadeSss2 = numero(ensaio2.densidadeSss2);
  const densidades = [densidadeSss1, densidadeSss2].filter((valor) => valor !== null);

  return {
    ...densidade,
    ...ensaio1,
    ...ensaio2,
    densidadeMedia:
      densidades.length > 0
        ? numeroBR(densidades.reduce((total, valor) => total + valor, 0) / densidades.length, 3)
        : "",
  };
}

function recalcularMassaUnitaria(massaUnitaria) {
  const calcularEnsaio = (sufixo) => {
    const volume = numero(massaUnitaria[`volume${sufixo}`]);
    const recipienteVazio = numero(massaUnitaria[`recipienteVazio${sufixo}`]);
    const recipienteAgregado = numero(massaUnitaria[`recipienteAgregado${sufixo}`]);
    const massaAgregado =
      recipienteAgregado !== null && recipienteVazio !== null
        ? recipienteAgregado - recipienteVazio
        : null;
    const massaUnitariaCalculada =
      massaAgregado !== null && volume ? massaAgregado / volume : null;

    return {
      [`massaAgregado${sufixo}`]:
        massaAgregado !== null ? numeroBR(massaAgregado, 0) : "",
      [`massaUnitaria${sufixo}`]:
        massaUnitariaCalculada !== null ? numeroBR(massaUnitariaCalculada, 3) : "",
    };
  };

  const ensaio1 = calcularEnsaio("1");
  const ensaio2 = calcularEnsaio("2");
  const massaUnitaria1 = numero(ensaio1.massaUnitaria1);
  const massaUnitaria2 = numero(ensaio2.massaUnitaria2);
  const valores = [massaUnitaria1, massaUnitaria2].filter((valor) => valor !== null);

  return {
    ...massaUnitaria,
    ...ensaio1,
    ...ensaio2,
    mediaMassaUnitaria:
      valores.length > 0
        ? numeroBR(valores.reduce((total, valor) => total + valor, 0) / valores.length, 3)
        : "",
  };
}

function recalcularTorroesPulverulentos(torroesPulverulentos) {
  const calcularPercentual = (prefixo) => {
    const antes = numero(torroesPulverulentos[`${prefixo}Antes`]);
    const depois = numero(torroesPulverulentos[`${prefixo}Depois`]);
    const percentual =
      antes !== null && depois !== null && antes ? ((antes - depois) / antes) * 100 : null;

    return percentual !== null ? numeroBR(percentual, 1) : "";
  };

  return {
    ...torroesPulverulentos,
    torroesPercentual: calcularPercentual("torroes"),
    pulverulentosPercentual: calcularPercentual("pulverulentos"),
  };
}

function recalcularCaracterizacao(dados) {
  return recalcularGranulometria({
    ...dados,
    densidade: recalcularDensidade(dados.densidade || {}),
    massaUnitaria: recalcularMassaUnitaria(dados.massaUnitaria || {}),
    torroesPulverulentos: recalcularTorroesPulverulentos(dados.torroesPulverulentos || {}),
    equivalenteAreia: recalcularEquivalenteAreia(dados.equivalenteAreia || {}),
  });
}

function ValorCelula({ children, destaque = false }) {
  return (
    <Typography
      sx={{
        color: destaque ? "primary.main" : "text.primary",
        fontSize: "0.82rem",
        fontWeight: destaque ? 700 : 500,
        minHeight: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children || "-"}
    </Typography>
  );
}

function InfoCadastro({ label, value }) {
  return (
    <Box
      sx={{
        border: "1px solid #d9dde5",
        borderRadius: "8px",
        minHeight: 42,
        px: 1,
        py: 0.55,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="caption" color="text.primary" fontWeight={700}>
        {label}:
      </Typography>
      <Typography
        color="text.secondary"
        sx={{
          mt: 0.35,
          lineHeight: 1.1,
          overflowWrap: "normal",
          whiteSpace: "nowrap",
          wordBreak: "normal",
        }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
}

function InfoCadastroSelect({ label, value, onChange, children }) {
  return (
    <Box
      sx={{
        border: "1px solid #d9dde5",
        borderRadius: "8px",
        minHeight: 42,
        px: 1,
        py: 0.55,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="caption" color="text.primary" fontWeight={700}>
        {label}:
      </Typography>
      <TextField
        select
        value={value}
        onChange={onChange}
        size="small"
        variant="standard"
        fullWidth
        SelectProps={{ displayEmpty: true }}
        sx={{
          mt: 0.1,
          "& .MuiInputBase-root": { minHeight: 18, fontSize: "0.95rem" },
          "& .MuiSelect-select": { py: 0, color: "text.secondary" },
        }}
      >
        {children}
      </TextField>
    </Box>
  );
}

const inputTabelaSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "3px",
  },
  "& .MuiInputBase-input": {
    p: "5px 2px",
    textAlign: "center",
    fontSize: "0.78rem",
  },
};

const celulaInputSx = {
  p: "1px",
  width: 72,
};

export default function DetalhesCaracterizacao() {
  const { caracterizacaoId } = useParams();
  const history = useHistory();
  const [caracterizacao, setCaracterizacao] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [estadoOriginalEdicao, setEstadoOriginalEdicao] = useState("");
  const caracterizacaoOriginalRef = useRef(null);
  const [modoPrint, setModoPrint] = useState(false);
  const [modoRelatorio, setModoRelatorio] = useState(false);
  const [codigoRelatorio, setCodigoRelatorio] = useState("");
  const [dataRelatorio, setDataRelatorio] = useState("");
  const [relatorioSalvo, setRelatorioSalvo] = useState(false);
  const [salvandoRelatorio, setSalvandoRelatorio] = useState(false);
  const [ensaiosSolicitados, setEnsaiosSolicitados] = useState([]);
  const [restritoPorSolicitacao, setRestritoPorSolicitacao] = useState(false);
  const [alturaCabecalhoFixo, setAlturaCabecalhoFixo] = useState(94);
  const cabecalhoFixoRef = useRef(null);
  const [fotosEquivalenteAreia, setFotosEquivalenteAreia] = useState({
    antes: null,
    depois: null,
  });
  const [normaDialog, setNormaDialog] = useState({
    open: false,
    campo: "",
    valor: "",
  });

  useEffect(() => {
    carregarCaracterizacao();
  }, [caracterizacaoId]);

  useEffect(() => {
    const cabecalho = cabecalhoFixoRef.current;
    if (!cabecalho || modoPrint || modoRelatorio) return undefined;

    const atualizarAltura = () => {
      setAlturaCabecalhoFixo(Math.ceil(cabecalho.getBoundingClientRect().height));
    };
    atualizarAltura();

    const observador = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(atualizarAltura)
      : null;
    observador?.observe(cabecalho);
    window.addEventListener("resize", atualizarAltura);

    return () => {
      observador?.disconnect();
      window.removeEventListener("resize", atualizarAltura);
    };
  }, [caracterizacao?.id, modoPrint, modoRelatorio]);

  async function carregarCaracterizacao() {
    const snap = await getDoc(doc(db, "tblCaracterizacaoAgregados", caracterizacaoId));
    if (!snap.exists()) return;

    const dados = snap.data();
    const solicitacaoId = new URLSearchParams(window.location.search).get("solicitacaoId") || "";
    setRestritoPorSolicitacao(Boolean(solicitacaoId));
    if (solicitacaoId) {
      const solicitacaoSnap = await getDoc(doc(db, "tblSolicitacoesServicos", solicitacaoId));
      if (solicitacaoSnap.exists()) {
        setEnsaiosSolicitados(
          (solicitacaoSnap.data().ensaios || [])
            .map((ensaio) => ensaio.id)
            .filter((id) => String(id || "").startsWith("caracterizacao-"))
        );
      }
    } else {
      setEnsaiosSolicitados([]);
    }
    if (pareceAgregadoGraudo(dados)) {
      history.replace(`/app/cadastro-caracterizacao/${caracterizacaoId}`);
      return;
    }
    let codigoFornecedor = dados.codigoFornecedor || "";

    if (!codigoFornecedor && dados.fornecedorId) {
      const fornecedorSnap = await getDoc(doc(db, "tblListaMateriaisCadastrados", dados.fornecedorId));
      codigoFornecedor = fornecedorSnap.exists() ? fornecedorSnap.data()?.codigo || "" : "";
    }

    const caracterizacaoCarregada = recalcularCaracterizacao({
      id: snap.id,
      ...dados,
      codigoFornecedor,
      granulometria: peneirasPadrao.map((peneira, index) => ({
        ...granulometriaModelo[index],
        ...(dados.granulometria?.[index] || {}),
        peneira,
      })),
      densidade: { ...densidadeInicial, ...(dados.densidade || {}) },
      massaUnitaria: { ...massaUnitariaInicial, ...(dados.massaUnitaria || {}) },
      torroesPulverulentos: {
        ...torroesPulverulentosInicial,
        ...(dados.torroesPulverulentos || {}),
      },
      impurezasOrganicas: {
        ...impurezasOrganicasInicial,
        ...(dados.impurezasOrganicas || dados.impurezas || {}),
      },
      equivalenteAreia: recalcularEquivalenteAreia(dados.equivalenteAreia || {}),
      particulasLeves: {
        ...particulasLevesInicial,
        ...(dados.particulasLeves || {}),
      },
      saisCloretosSulfatos: {
        ...saisCloretosSulfatosInicial,
        ...(dados.saisCloretosSulfatos || dados.sais || {}),
      },
      normaReferencia: {
        ...normaReferenciaInicial,
        ...(dados.normaReferencia || {}),
      },
    });
    setCaracterizacao(caracterizacaoCarregada);
    caracterizacaoOriginalRef.current = caracterizacaoCarregada;
    setEstadoOriginalEdicao(JSON.stringify(caracterizacaoCarregada));
  }

  function ensaioHabilitado(ensaioId) {
    return !restritoPorSolicitacao || ensaiosSolicitados.includes(ensaioId);
  }

  function numeroDoCodigoRelatorio(relatorio) {
    const codigo = String(relatorio?.codigoRelatorio || "").trim();
    const codigoPadrao = codigo.match(/^RE-CA-(\d+)(?:\.[A-Z0-9]+)?\/\d{4}$/i);
    return Number(relatorio?.codigoBase || relatorio?.numeroRelatorio || codigoPadrao?.[1] || codigo.split(".")[0] || 0);
  }

  function abrirRelatorio() {
    history.push("/app/relatorios/caracterizacao", {
      materialId: caracterizacao.id,
      abrirPrevia: true,
    });
  }

  async function salvarRelatorio() {
    if (relatorioSalvo || salvandoRelatorio) return;

    setSalvandoRelatorio(true);
    try {
      const relatoriosSnap = await getDocs(
        consultaTenantAtual(collection(db, "tblRelatoriosCaracterizacaoAgregados"))
      );
      const maiorNumeroExistente = relatoriosSnap.docs.reduce(
        (maior, item) => Math.max(maior, numeroDoCodigoRelatorio(item.data()) || 0),
        0
      );
      const sequencial = await gerarSequencial({
        chave: "relatorio_caracterizacao",
        valorMinimo: maiorNumeroExistente,
      });
      const codigoBase = String(sequencial.numero);
      const ano = String(dataRelatorio || new Date().toISOString().slice(0, 10)).slice(0, 4);
      const codigoGerado = `RE-CA-${codigoBase}/${ano}`;

      await addDoc(collection(db, "tblRelatoriosCaracterizacaoAgregados"), aplicarTenantAtual({
        clienteId: caracterizacao.clienteId || "",
        clienteNome: caracterizacao.clienteNome || caracterizacao.cliente || "",
        obraId: caracterizacao.obraId || "",
        obraNome: caracterizacao.obraNome || caracterizacao.obra || "",
        data: dataRelatorio || new Date().toISOString().slice(0, 10),
        materialIds: [caracterizacao.id],
        materiaisResumo: [{
          id: caracterizacao.id,
          codigo: caracterizacao.codigoFornecedor || caracterizacao.fornecedorCodigo || caracterizacao.codigoMaterial || caracterizacao.codigo || "",
          descricao: caracterizacao.amostra || caracterizacao.descricao || "",
          fornecedor: caracterizacao.procedencia || caracterizacao.fornecedor || "",
          tipoAgregado: "miudo",
        }],
        numeroRelatorio: Number(codigoBase),
        codigoRelatorio: codigoGerado,
        codigoBase,
        complementoCodigo: null,
        anexos: [],
        criadoEm: new Date(),
        atualizadoEm: new Date(),
      }));
      setCodigoRelatorio(codigoGerado);
      setRelatorioSalvo(true);
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar relatório.");
    } finally {
      setSalvandoRelatorio(false);
    }
  }

  function atualizarCampo(campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({ ...prev, [campo]: valor }));
  }

  function atualizarGranulometria(index, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      granulometria: prev.granulometria.map((linha, linhaIndex) =>
        linhaIndex === index ? { ...linha, [campo]: valor } : linha
      ),
    }));
  }

  function atualizarGrupo(grupo, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      [grupo]: {
        ...prev[grupo],
        [campo]: valor,
      },
    }));
  }

  function atualizarEnsaioEquivalenteAreia(index, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      equivalenteAreia: recalcularEquivalenteAreia({
        ...(prev.equivalenteAreia || {}),
        ensaios: (prev.equivalenteAreia?.ensaios || []).map((ensaio, ensaioIndex) =>
          ensaioIndex === index ? { ...ensaio, [campo]: valor } : ensaio
        ),
      }),
    }));
  }

  function selecionarFotoEquivalenteAreia(tipo, arquivo) {
    if (!arquivo) return;
    if (!arquivo.type.startsWith("image/")) {
      setMensagem("Selecione um arquivo de imagem.");
      return;
    }

    setMensagem("");
    setFotosEquivalenteAreia((prev) => {
      if (prev[tipo]?.previewUrl) URL.revokeObjectURL(prev[tipo].previewUrl);
      return {
        ...prev,
        [tipo]: {
          arquivo,
          previewUrl: URL.createObjectURL(arquivo),
        },
      };
    });
  }

  async function salvarFotoEquivalenteAreia(tipo, fotoAtual) {
    const draft = fotosEquivalenteAreia[tipo];
    if (!draft?.arquivo) return fotoAtual || null;

    const arquivoComprimido = await compressImage(draft.arquivo, {
      maxWidth: 1400,
      maxHeight: 1400,
      quality: 0.75,
    });
    const caminho = `caracterizacoes/${caracterizacao.id}/equivalente-areia/${tipo}-${Date.now()}.jpg`;
    const storageRef = ref(storage, caminho);
    await uploadBytes(storageRef, arquivoComprimido, { contentType: "image/jpeg" });
    const url = await getDownloadURL(storageRef);

    if (fotoAtual?.path) {
      deleteObject(ref(storage, fotoAtual.path)).catch(() => {});
    }

    return {
      url,
      path: caminho,
      nomeArquivo: draft.arquivo.name,
    };
  }

  function recalcularTela() {
    setCaracterizacao((prev) => recalcularCaracterizacao(prev));
  }

  function recalcularGranulometriaTela() {
    setCaracterizacao((prev) => recalcularGranulometria(prev));
  }

  function recalcularGrupo(grupo, dadosGrupo) {
    if (grupo === "densidade") return recalcularDensidade(dadosGrupo || {});
    if (grupo === "massaUnitaria") return recalcularMassaUnitaria(dadosGrupo || {});
    if (grupo === "torroesPulverulentos") return recalcularTorroesPulverulentos(dadosGrupo || {});
    return dadosGrupo || {};
  }

  function recalcularGrupoTela(grupo) {
    setCaracterizacao((prev) => ({
      ...prev,
      [grupo]: recalcularGrupo(grupo, prev[grupo] || {}),
    }));
  }

  function abrirNormaReferencia(campo) {
    const normas = {
      ...normaReferenciaInicial,
      ...(caracterizacao.normaReferencia || {}),
    };
    setNormaDialog({
      open: true,
      campo,
      valor: normas[campo] || "",
    });
  }

  function fecharNormaReferencia() {
    setNormaDialog({ open: false, campo: "", valor: "" });
  }

  async function salvarNormaReferencia() {
    if (!normaDialog.campo) return;

    const normaReferencia = {
      ...normaReferenciaInicial,
      ...(caracterizacao.normaReferencia || {}),
      [normaDialog.campo]: normaDialog.valor,
    };

    try {
      const dadosSalvos = await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblCaracterizacaoAgregados", caracterizacao.id),
        original: caracterizacaoOriginalRef.current,
        atual: { ...caracterizacaoOriginalRef.current, normaReferencia },
        metadados: { atualizadoEm: new Date() },
      });
      caracterizacaoOriginalRef.current = { id: caracterizacao.id, ...dadosSalvos };
      setCaracterizacao((prev) => {
        const atualizado = { ...prev, normaReferencia };
        setEstadoOriginalEdicao(JSON.stringify(atualizado));
        return atualizado;
      });
      setMensagem("Norma de referência salva com sucesso!");
      fecharNormaReferencia();
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar norma de referência.");
    }
  }

  function handleEnterCelula(event, grupo, campo, index) {
    if (event.key !== "Enter") return;

    event.preventDefault();
    event.target.blur();

    const proximo = document.querySelector(
      `[data-caracterizacao-grupo='${grupo}'][data-caracterizacao-campo='${campo}'][data-caracterizacao-index='${index + 1}']`
    );

    if (proximo) proximo.focus();
  }

  function avancarCampoComEnter(event) {
    if (event.key !== "Enter") return;

    const campoAtual = event.target.closest("input, textarea, select, [contenteditable='true']");
    if (!campoAtual) return;

    event.preventDefault();

    if (campoAtual.dataset.caracterizacaoGrupo === "equivalenteAreia") {
      const campo = campoAtual.dataset.caracterizacaoCampo;
      const index = Number(campoAtual.dataset.caracterizacaoIndex);
      const ultimoIndiceAreia =
        event.currentTarget.querySelectorAll(
          "[data-caracterizacao-grupo='equivalenteAreia'][data-caracterizacao-campo='alfa']"
        ).length - 1;
      const proximoCampo =
        campo === "alfa"
          ? document.querySelector(
              `[data-caracterizacao-grupo='equivalenteAreia'][data-caracterizacao-campo='${
                index < ultimoIndiceAreia ? "alfa" : "beta"
              }'][data-caracterizacao-index='${index < ultimoIndiceAreia ? index + 1 : 0}']`
            )
          : document.querySelector(
              `[data-caracterizacao-grupo='equivalenteAreia'][data-caracterizacao-campo='beta'][data-caracterizacao-index='${
                index + 1
              }']`
            );

      campoAtual.blur();
      if (proximoCampo) {
        proximoCampo.focus();
        proximoCampo.select?.();
      }
      return;
    }

    const campos = Array.from(
      event.currentTarget.querySelectorAll("input, textarea, select, [contenteditable='true']")
    ).filter((campo) => {
      const input = campo;
      return (
        input.type !== "hidden" &&
        !input.disabled &&
        !input.readOnly &&
        input.tabIndex !== -1 &&
        input.offsetParent !== null
      );
    });

    const indiceAtual = campos.indexOf(campoAtual);
    const proximoCampo = campos[indiceAtual + 1];

    campoAtual.blur();
    if (proximoCampo) {
      proximoCampo.focus();
      proximoCampo.select?.();
    }
  }

  async function salvarTudo() {
    setSalvando(true);
    setMensagem("");

    try {
      const equivalenteAtual = recalcularEquivalenteAreia(caracterizacao.equivalenteAreia || {});
      const caracterizacaoParaValidar = recalcularCaracterizacao({
        ...caracterizacao,
        equivalenteAreia: equivalenteAtual,
      });
      const pendentesData = ensaiosComDataPendente(caracterizacaoParaValidar);
      if (pendentesData.length) {
        setMensagem(`É obrigatório o preenchimento da data em ensaios cadastrados: ${pendentesData.join(", ")}.`);
        return;
      }

      const possuiDadosEquivalente = Boolean(
        equivalenteAtual.data ||
          equivalenteAtual.ensaios.some((ensaio) => ensaio.alfa || ensaio.beta)
      );
      const possuiFotoAntes = Boolean(fotosEquivalenteAreia.antes?.arquivo || equivalenteAtual.fotoAntes?.url);
      const possuiFotoDepois = Boolean(fotosEquivalenteAreia.depois?.arquivo || equivalenteAtual.fotoDepois?.url);

      if (possuiDadosEquivalente && (!possuiFotoAntes || !possuiFotoDepois)) {
        setMensagem("Anexe as fotos ANTES e DEPOIS do ensaio de equivalente de areia.");
        return;
      }

      const fotoAntes = await salvarFotoEquivalenteAreia("antes", equivalenteAtual.fotoAntes);
      const fotoDepois = await salvarFotoEquivalenteAreia("depois", equivalenteAtual.fotoDepois);
      const caracterizacaoRecalculada = recalcularCaracterizacao({
        ...caracterizacao,
        equivalenteAreia: {
          ...equivalenteAtual,
          fotoAntes,
          fotoDepois,
        },
      });
      const caracterizacaoParaSalvar = {
        ...caracterizacaoRecalculada,
        tipoAgregado: "miudo",
      };
      const { id } = caracterizacaoParaSalvar;
      const dadosSalvos = await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblCaracterizacaoAgregados", id),
        original: caracterizacaoOriginalRef.current,
        atual: caracterizacaoParaSalvar,
        preparar: (dadosMesclados) => {
          const { id: _id, ...dados } = dadosMesclados;
          return recalcularCaracterizacao(dados);
        },
        metadados: { atualizadoEm: new Date() },
      });
      Object.values(fotosEquivalenteAreia).forEach((foto) => {
        if (foto?.previewUrl) URL.revokeObjectURL(foto.previewUrl);
      });
      setFotosEquivalenteAreia({ antes: null, depois: null });
      const caracterizacaoSalva = { id, ...dadosSalvos };
      setCaracterizacao(caracterizacaoSalva);
      caracterizacaoOriginalRef.current = caracterizacaoSalva;
      setEstadoOriginalEdicao(JSON.stringify(caracterizacaoSalva));
      setMensagem("Salvo com sucesso!");
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar dados.");
    } finally {
      setSalvando(false);
    }
  }

  if (!caracterizacao) return null;

  const temFotosAlteradas = Object.values(fotosEquivalenteAreia).some(
    (foto) => Boolean(foto?.arquivo)
  );
  const temAlteracoes =
    temFotosAlteradas ||
    (Boolean(estadoOriginalEdicao) &&
      JSON.stringify(caracterizacao) !== estadoOriginalEdicao);

  async function cancelarAlteracoes() {
    if (!(await confirmarSistema("Deseja cancelar todas as alterações não salvas?"))) return;
    Object.values(fotosEquivalenteAreia).forEach((foto) => {
      if (foto?.previewUrl) URL.revokeObjectURL(foto.previewUrl);
    });
    setFotosEquivalenteAreia({ antes: null, depois: null });
    setMensagem("");
    await carregarCaracterizacao();
  }

if (modoPrint) {
  return (
    <RelatorioCaracterizacaoMiudoPrint
      caracterizacao={caracterizacao}
      onVoltar={() => setModoPrint(false)}
    />
  );
}

if (modoRelatorio) {
  return (
    <RelatorioCaracterizacaoResumoPrint
      relatorio={{
        codigoRelatorio,
        data: dataRelatorio,
        clienteNome: caracterizacao.clienteNome || caracterizacao.cliente || "",
        obraNome: caracterizacao.obraNome || caracterizacao.obra || "",
        anexos: [],
      }}
      caracterizacoes={[
        {
          ...caracterizacao,
          tipoAgregado: "miudo",
        },
      ]}
      anexosEnsaios={[]}
      cliente={{
        nome: caracterizacao.clienteNome || caracterizacao.cliente || "",
      }}
      obra={{
        nome: caracterizacao.obraNome || caracterizacao.obra || "",
      }}
      autoPrint={false}
      onSalvar={relatorioSalvo ? undefined : salvarRelatorio}
      salvando={salvandoRelatorio}
      onVoltar={() => setModoRelatorio(false)}
    />
  );
}

  const tipoAgregadoGrafico = "Miúdo";
  const densidadeLinhas = [
    ["A", "Material (sss)", "-", "materialSss1", "materialSss2", true],
    ["B", "Frasco+ Material (sss) + água", "-", "frascoMaterial1", "frascoMaterial2", true],
    ["C", "Frasco+ água", "-", "frascoAgua1", "frascoAgua2", true],
    ["D", "Peso do material imerso", "D = B - C", "pesoImerso1", "pesoImerso2"],
    ["E", "Massa de água deslocada (g)", "E = A - D", "volumeSss1", "volumeSss2"],
    ["F", "Massa de água equivalente ao volume real (g)", "F = G - D", "volumeSeco1", "volumeSeco2"],
    ["G", "Material seco estufa", "-", "materialSeco1", "materialSeco2", true],
    ["", "Densidades relativas (sem unidade)", "-", "", ""],
    ["H", "Densidade relativa do agregado (sss)", "H = A / E", "densidadeSss1", "densidadeSss2"],
    ["I", "Densidade relativa do agregado (seco)", "I = G / E", "densidadeSeco1", "densidadeSeco2"],
    ["J", "Densidade relativa média (sss)", "J = (H1 + H2) / 2", "densidadeMedia", ""],
    ["Ab)", "Absorção do agregado (%)", "[(A - G) / G] * 100", "absorcao1", "absorcao2"],
  ];
  const massaUnitariaLinhas = [
    ["-", "Determinações", "-", "1", "2"],
    ["A", "Volume do recipiente (dm3)", "-", "volume1", "volume2", true],
    ["B", "Massa do recipiente vazio g", "-", "recipienteVazio1", "recipienteVazio2", true],
    ["C", "Massa do recipiente + agregado g", "-", "recipienteAgregado1", "recipienteAgregado2", true],
    ["D", "Massa do agregado g", "D = C - B", "massaAgregado1", "massaAgregado2"],
    ["E", "M. unitária solta do agregado", "E = D / A", "massaUnitaria1", "massaUnitaria2"],
    ["F", "Média da massa unitária solta (g/cm3)", "F = (E1 + E2) / 2", "mediaMassaUnitaria", ""],
  ];
  const torroesPulverulentosLinhas = [
    ["antes", "torroesAntes", "pulverulentosAntes", true],
    ["depois", "torroesDepois", "pulverulentosDepois", true],
    ["%", "torroesPercentual", "pulverulentosPercentual"],
  ];

  function renderValorGrupo(grupo, campo, editavel, index) {
    const dados = caracterizacao[grupo] || {};
    if (!campo) return <ValorCelula>-</ValorCelula>;

    if (campo === "1" || campo === "2") {
      return <ValorCelula>{campo}</ValorCelula>;
    }

    if (!editavel) {
      return <ValorCelula destaque={campo.includes("Media") || campo.includes("media")}>{dados[campo]}</ValorCelula>;
    }

    return (
      <TextField
        size="small"
        value={dados[campo] || ""}
        onChange={(e) => atualizarGrupo(grupo, campo, e.target.value)}
        onBlur={() => recalcularGrupoTela(grupo)}
        onKeyDown={(event) => handleEnterCelula(event, grupo, campo, index)}
        inputProps={{
          "data-caracterizacao-grupo": grupo,
          "data-caracterizacao-campo": campo,
          "data-caracterizacao-index": index,
        }}
        sx={inputTabelaSx}
      />
    );
  }

  function renderImpurezasOrganicas() {
    const impurezas = caracterizacao.impurezasOrganicas || {};

    return (
      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography fontWeight={700} mb={2}>
          Impurezas Orgânicas
        </Typography>

        <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "220px 1fr" }} gap={2} alignItems="center">
          <TextField
            label="Data do ensaio"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={impurezas.data || ""}
            onChange={(e) => atualizarGrupo("impurezasOrganicas", "data", e.target.value)}
            size="small"
          />

          <Box>
            <Typography fontWeight={700} mb={1}>
              Clareza em relação ao Padrão:
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(impurezas.clarezaMaisClara)}
                  onChange={(e) => atualizarGrupo("impurezasOrganicas", "clarezaMaisClara", e.target.checked)}
                />
              }
              label="mais clara"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(impurezas.relacaoIgual)}
                  onChange={(e) => atualizarGrupo("impurezasOrganicas", "relacaoIgual", e.target.checked)}
                />
              }
              label="igual"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(impurezas.padraoMaisEscura)}
                  onChange={(e) => atualizarGrupo("impurezasOrganicas", "padraoMaisEscura", e.target.checked)}
                />
              }
              label="mais escura"
            />
            </Box>
          </Box>
        </Box>
      </Paper>
    );
  }

  function renderTorroesPulverulentos() {
    return (
      <>
        {renderNormaReferencia("torroesArgila")}
        {renderNormaReferencia("materialPulverulento")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 560, tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 120 }} />
              <col style={{ width: 220 }} />
              <col style={{ width: 220 }} />
            </colgroup>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell />
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  Torr{"\u00f5"}es de argila
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  Pulverulento
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Data:</TableCell>
                <TableCell sx={celulaInputSx}>
                  <TextField
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataTorroesArgila || ""}
                    onChange={(e) => atualizarCampo("dataTorroesArgila", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell sx={celulaInputSx}>
                  <TextField
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataMateriaisPulverulentos || ""}
                    onChange={(e) => atualizarCampo("dataMateriaisPulverulentos", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>

              {torroesPulverulentosLinhas.map(([descricao, campoTorroes, campoPulverulentos, editavel], index) => (
                <TableRow key={descricao}>
                  <TableCell align="center">{descricao}</TableCell>
                  <TableCell sx={celulaInputSx}>
                    {renderValorGrupo("torroesPulverulentos", campoTorroes, editavel, index)}
                  </TableCell>
                  <TableCell sx={celulaInputSx}>
                    {renderValorGrupo("torroesPulverulentos", campoPulverulentos, editavel, index)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </>
    );
  }

  function renderParticulasLeves() {
    const dados = caracterizacao.particulasLeves || {};

    return (
      <>
        {renderNormaReferencia("particulasLeves")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography>Data do ensaio:</Typography>
            <TextField
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dados.data || ""}
              onChange={(e) => atualizarGrupo("particulasLeves", "data", e.target.value)}
              size="small"
              sx={{ ...inputTabelaSx, maxWidth: 180 }}
            />
          </Box>

          <Table size="small" sx={{ maxWidth: 820, tableLayout: "fixed" }}>
            <TableBody>
              <TableRow>
                <TableCell align="center">TEOR DE PARTÍCULAS LEVES (%)</TableCell>
                <TableCell sx={celulaInputSx}>
                  <TextField
                    value={dados.teor || ""}
                    onChange={(e) => atualizarGrupo("particulasLeves", "teor", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell align="center">Massa Específica da Solução do ensaio</TableCell>
                <TableCell sx={celulaInputSx}>
                  <TextField
                    value={dados.massaEspecificaSolucao || ""}
                    onChange={(e) => atualizarGrupo("particulasLeves", "massaEspecificaSolucao", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell rowSpan={3} align="center">
                  Quantidade Máxima Relativa à Massa do Agregado (%)
                </TableCell>
                <TableCell colSpan={3} align="center">Limites: NBR 7211/09 - ASTM 123</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} align="center">Concreto Aparente</TableCell>
                <TableCell align="center">0,5</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} align="center">Concreto Não Aparente</TableCell>
                <TableCell align="center">1,0</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography sx={{ mt: 2 }}>
            A amostra analisada atende as especificações da ABNT NBR 7211/2022 quanto os ensaios realizados para Teor de partículas leves (materiais carbonosos).
          </Typography>
        </Paper>
      </>
    );
  }

  function renderEquivalenteAreia() {
    const dados = caracterizacao.equivalenteAreia || equivalenteAreiaInicial;
    const fotoAntes = fotosEquivalenteAreia.antes?.previewUrl || dados.fotoAntes?.url;
    const fotoDepois = fotosEquivalenteAreia.depois?.previewUrl || dados.fotoDepois?.url;

    return (
      <>
        {renderNormaReferencia("equivalenteAreia")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography>Data do ensaio:</Typography>
            <TextField
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dados.data || ""}
              onChange={(e) => atualizarGrupo("equivalenteAreia", "data", e.target.value)}
              size="small"
              sx={{ ...inputTabelaSx, maxWidth: 180 }}
            />
          </Box>

          <Table size="small" sx={{ minWidth: 720, tableLayout: "fixed" }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell align="center">ENSAIO N.º</TableCell>
                <TableCell align="center">LEITURA NO TOPO DA AREIA α (cm)</TableCell>
                <TableCell align="center">LEITURA NO TOPO DA ARGILA β (cm)</TableCell>
                <TableCell align="center">EQUIVALENTE DE AREIA (%)<br />EA = α / β × 100</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dados.ensaios.map((ensaio, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell sx={celulaInputSx}>
                    <TextField
                      value={ensaio.alfa || ""}
                      onChange={(e) => atualizarEnsaioEquivalenteAreia(index, "alfa", e.target.value)}
                      inputProps={{
                        "data-caracterizacao-grupo": "equivalenteAreia",
                        "data-caracterizacao-campo": "alfa",
                        "data-caracterizacao-index": index,
                      }}
                      size="small"
                      sx={inputTabelaSx}
                    />
                  </TableCell>
                  <TableCell sx={celulaInputSx}>
                    <TextField
                      value={ensaio.beta || ""}
                      onChange={(e) => atualizarEnsaioEquivalenteAreia(index, "beta", e.target.value)}
                      inputProps={{
                        "data-caracterizacao-grupo": "equivalenteAreia",
                        "data-caracterizacao-campo": "beta",
                        "data-caracterizacao-index": index,
                      }}
                      size="small"
                      sx={inputTabelaSx}
                    />
                  </TableCell>
                  <TableCell align="center">{ensaio.resultado || "-"}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="center" sx={{ fontWeight: 700 }}>MÉDIA</TableCell>
                <TableCell colSpan={2} />
                <TableCell align="center" sx={{ fontWeight: 700 }}>{dados.media || "-"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={2} mt={3}>
            {[
              ["antes", "ANTES", fotoAntes],
              ["depois", "DEPOIS", fotoDepois],
            ].map(([tipo, legenda, url]) => (
              <Box key={tipo} textAlign="center">
                <Button variant="outlined" component="label" fullWidth disabled={salvando}>
                  Anexar foto {legenda.toLowerCase()}
                  <input
                    hidden
                    type="file"
                    accept="image/jpeg,image/png,image/webp"
                    onChange={(event) => selecionarFotoEquivalenteAreia(tipo, event.target.files?.[0])}
                  />
                </Button>
                {url && (
                  <Box
                    component="img"
                    src={url}
                    alt={`Ensaio de equivalente de areia - ${legenda}`}
                    sx={{ display: "block", width: "100%", height: 260, objectFit: "contain", mt: 1, border: "1px solid #ddd" }}
                  />
                )}
                <Typography fontWeight={700} mt={1}>{legenda}</Typography>
              </Box>
            ))}
          </Box>
        </Paper>
      </>
    );
  }

  function renderSaisCloretosSulfatos() {
    const dados = caracterizacao.saisCloretosSulfatos || {};

    return (
      <>
        {renderNormaReferencia("saisCloretosSulfatos")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography>Data conclusão:</Typography>
            <TextField
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dados.data || ""}
              onChange={(e) => atualizarGrupo("saisCloretosSulfatos", "data", e.target.value)}
              size="small"
              sx={{ ...inputTabelaSx, maxWidth: 180 }}
            />
          </Box>

          <Table size="small" sx={{ maxWidth: 820, tableLayout: "fixed" }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow><TableCell colSpan={3} align="center">ENSAIOS</TableCell></TableRow>
              <TableRow>
                <TableCell align="center">TEOR DE CLORETOS (%)</TableCell>
                <TableCell align="center">TEOR DE SULFATOS (%)</TableCell>
                <TableCell align="center">TEOR DE SAIS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={celulaInputSx}>
                  <TextField value={dados.teorCloretos || ""} onChange={(e) => atualizarGrupo("saisCloretosSulfatos", "teorCloretos", e.target.value)} size="small" sx={inputTabelaSx} />
                </TableCell>
                <TableCell sx={celulaInputSx}>
                  <TextField value={dados.teorSulfatos || ""} onChange={(e) => atualizarGrupo("saisCloretosSulfatos", "teorSulfatos", e.target.value)} size="small" sx={inputTabelaSx} />
                </TableCell>
                <TableCell sx={celulaInputSx}>
                  <TextField value={dados.teorSais || ""} onChange={(e) => atualizarGrupo("saisCloretosSulfatos", "teorSais", e.target.value)} size="small" sx={inputTabelaSx} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">LIMITE NORMATIVO (CLORETO)</TableCell>
                <TableCell colSpan={2} align="center">&lt;0,2% para concreto simples, &lt;0,1 para concreto armado e &lt;0,01% para concreto protendido.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">LIMITE NORMATIVO (SULFATO)</TableCell>
                <TableCell colSpan={2} align="center">&lt;0,1%</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <TextField
            label="Observação"
            value={dados.observacao || ""}
            onChange={(e) => atualizarGrupo("saisCloretosSulfatos", "observacao", e.target.value)}
            fullWidth
            size="small"
            sx={{ mt: 2 }}
          />
        </Paper>
      </>
    );
  }

  function renderNormaReferencia(campo) {
    const normas = {
      ...normaReferenciaInicial,
      ...(caracterizacao.normaReferencia || {}),
    };

    return (
      <Typography
        onClick={() => abrirNormaReferencia(campo)}
        sx={{
          mb: 1,
          ml: 1.5,
          color: "text.primary",
          cursor: "pointer",
          fontSize: "0.95rem",
          fontWeight: 500,
          "&:hover": { color: "primary.main", textDecoration: "underline" },
        }}
      >
        {normas[campo] || "-"}
      </Typography>
    );
  }

const botoesAcao = (
  <Box display="flex" justifyContent="flex-end" gap={2}>
    <Button
      variant="outlined"
      onClick={() => setModoPrint(true)}
      disabled={salvando || temAlteracoes}
    >
      Visualizar
    </Button>

    <Button
      variant="contained"
      color="secondary"
      onClick={abrirRelatorio}
      disabled={salvando || temAlteracoes}
    >
      Relatório
    </Button>

    <Button
      variant="outlined"
      onClick={() => history.goBack()}
      disabled={salvando || temAlteracoes}
    >
      Voltar
    </Button>

    {temAlteracoes && (
      <>
        <Button
          variant="contained"
          onClick={salvarTudo}
          disabled={salvando}
        >
          {salvando ? "Salvando..." : "Salvar"}
        </Button>
        <Button data-confirmacao-cancelamento="propria" variant="outlined" onClick={cancelarAlteracoes} disabled={salvando}>
          Cancelar alterações
        </Button>
      </>
    )}
  </Box>
);

  return (
    <>
      <Navbar />
      <Box
        ref={cabecalhoFixoRef}
        sx={{
          position: "fixed",
          top: { xs: 68, md: 76 },
          left: { xs: 12, md: 24 },
          right: { xs: 12, md: 24 },
          zIndex: 1190,
        }}
      >
        <CabecalhoDetalhes
          titulo="Caracterização de Agregados"
          subtitulo="RQ 2.2.3-B   Rev.00 - 20/08/2025"
          sx={{ position: "static", top: "auto", zIndex: "auto", mx: 0, mt: 0 }}
        >
          {botoesAcao}
        </CabecalhoDetalhes>
      </Box>

      <Box aria-hidden="true" sx={{ height: `${alturaCabecalhoFixo + 12}px` }} />

      <Box sx={{ p: { xs: 2, md: 4 } }} component="form" autoComplete="off" onKeyDownCapture={avancarCampoComEnter}>
        {mensagem && (
          <Alert severity={mensagem.includes("sucesso") ? "success" : "error"} sx={{ mb: 2 }}>
            {mensagem}
          </Alert>
        )}

        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography fontWeight={700} mb={2}>
            DADOS DO CADASTRO
          </Typography>

          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              md: "1fr 1fr 2fr",
              lg: "1fr 1fr 2fr 2fr",
            }}
            gap={1}
          >
            <InfoCadastro label="CÓDIGO" value={caracterizacao.codigo} />
           
            <InfoCadastro label="CADASTRO" value={formatarDataBR(caracterizacao.dataCadastro || caracterizacao.criadoEm?.toDate?.()?.toISOString?.()?.slice(0, 10))} />
            <InfoCadastro label="AMOSTRA" value={caracterizacao.amostra} />
            <InfoCadastro label="PROCEDÊNCIA" value={caracterizacao.procedencia} />
            <InfoCadastro label="LOCAL DA COLETA" value={caracterizacao.localColeta} />
          </Box>
        </Paper>

        <fieldset disabled={!ensaioHabilitado("caracterizacao-granulometria")} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: ensaioHabilitado("caracterizacao-granulometria") ? 1 : 0.45 }}>
        <Paper sx={{ p: 2, mb: 3 }}>
          {renderNormaReferencia("granulometria")}

          <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "repeat(4, 1fr)" }} gap={2} mb={2}>
           
            <TextField
              label="Data"
              type="date"
              value={caracterizacao.dataGranulometria || ""}
              onChange={(e) => atualizarCampo("dataGranulometria", e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
            />
            <TextField label="Operador" value={caracterizacao.operadorGranulometria || ""} onChange={(e) => atualizarCampo("operadorGranulometria", e.target.value)} size="small" />
            <TextField label="Massa inicial A" value={caracterizacao.massaInicialA || ""} onChange={(e) => atualizarCampo("massaInicialA", e.target.value)} onBlur={recalcularGranulometriaTela} size="small" />
            <TextField label="Massa inicial B" value={caracterizacao.massaInicialB || ""} onChange={(e) => atualizarCampo("massaInicialB", e.target.value)} onBlur={recalcularGranulometriaTela} size="small" />
          </Box>

          <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 1240 }}>
              <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                <TableRow>
                  <TableCell rowSpan={2} align="center">Abertura da<br />malha das<br />peneiras</TableCell>
                  <TableCell colSpan={2} align="center">Massa retida (g)</TableCell>
                  <TableCell colSpan={2} align="center">Massa retida (%)</TableCell>
                  <TableCell rowSpan={2} align="center">Variação<br />+- 4 %</TableCell>
                  <TableCell rowSpan={2} align="center">Média<br />(%)</TableCell>
                  <TableCell rowSpan={2} align="center">Acumulada<br />(%)</TableCell>
                  <TableCell colSpan={4} align="center">
                    Faixa em relação as % retidas NBR 7211
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">Ensaio a</TableCell>
                  <TableCell align="center">Ensaio b</TableCell>
                  <TableCell align="center">Ensaio a</TableCell>
                  <TableCell align="center">Ensaio b</TableCell>
                  {zonas.map((zona, zonaIndex) => (
                    <TableCell key={`${zona}-${zonaIndex}`} align="center">
                      {zona}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {caracterizacao.granulometria.map((linha, index) => (
                  <TableRow key={linha.peneira}>
                    <TableCell align="center" sx={{ width: 74 }}>{linha.peneira}</TableCell>
                    {["massaA", "massaB"].map((campo) => (
                      <TableCell key={campo} sx={celulaInputSx}>
                        <TextField
                          size="small"
                          value={linha[campo] || ""}
                          onChange={(e) => atualizarGranulometria(index, campo, e.target.value)}
                          onBlur={recalcularGranulometriaTela}
                          onKeyDown={(event) => handleEnterCelula(event, "granulometria", campo, index)}
                          inputProps={{
                            "data-caracterizacao-grupo": "granulometria",
                            "data-caracterizacao-campo": campo,
                            "data-caracterizacao-index": index,
                          }}
                          sx={inputTabelaSx}
                        />
                      </TableCell>
                    ))}
                    {["retidaA", "retidaB", "variacao", "media", "acumulada"].map((campo) => (
                      <TableCell key={campo} sx={{ p: "3px", width: 72 }}>
                        <ValorCelula destaque={campo === "acumulada"}>
                          {linha[campo]}
                        </ValorCelula>
                      </TableCell>
                    ))}
                    {faixas[index].map((faixa, faixaIndex) => (
                      <TableCell
                        key={faixaIndex}
                        align="center"
                        sx={{
                          width: 72,
                        }}
                      >
                        {faixa}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Total</TableCell>
                  <TableCell align="center">{caracterizacao.totalMassaA}</TableCell>
                  <TableCell align="center">{caracterizacao.totalMassaB}</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Ø máx.</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    {caracterizacao.diferencaMaxima}
                  </TableCell>
                  <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                    Módulo de finura
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#d00 !important", fontWeight: 700 }}>
                    {caracterizacao.moduloFinura}
                  </TableCell>
                  {toleranciasModuloFinura.map((tolerancia) => (
                    <TableCell key={tolerancia} align="center">
                      {tolerancia}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>diferença</TableCell>
                  <TableCell align="center">{caracterizacao.diferencaMassaA}</TableCell>
                  <TableCell align="center">{caracterizacao.diferencaMassaB}</TableCell>
                  <TableCell colSpan={9} />
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          <Box className="relatorio-caracterizacao-print" sx={{ mt: 2 }}>
            <ChartGranulometria
              linhas={caracterizacao.granulometria}
              amostra={caracterizacao.amostra}
              tipoAgregado={tipoAgregadoGrafico}
            />
          </Box>
        </Paper>

        </fieldset>
        <fieldset disabled={!ensaioHabilitado("caracterizacao-densidade-absorcao")} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: ensaioHabilitado("caracterizacao-densidade-absorcao") ? 1 : 0.45 }}>
        {renderNormaReferencia("densidade")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 900, tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 42 }} />
              <col style={{ width: 300 }} />
              <col style={{ width: 120 }} />
              <col style={{ width: 145 }} />
              <col style={{ width: 145 }} />
            </colgroup>
            <TableBody>
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 700 }}>Data:</TableCell>
                <TableCell>
                  <TextField
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataDensidade || ""}
                    onChange={(e) => atualizarCampo("dataDensidade", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell align="left" sx={{ color: "#003f8f", fontWeight: 700 }}>
                  DENSIDADE E ABSORÇÃO NBR 16917
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>OPERADOR:</TableCell>
                <TableCell>
                  <TextField
                    value={caracterizacao.operadorDensidade || ""}
                    onChange={(e) => atualizarCampo("operadorDensidade", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>

              {densidadeLinhas.map(([letra, descricao, formula, campo1, campo2, editavel], index) => (
                <TableRow key={`${letra}-${descricao}`}>
                  <TableCell align="center" sx={{ width: 42 }}>{letra}</TableCell>
                  <TableCell>{descricao}</TableCell>
                  <TableCell align="center">{formula}</TableCell>
                  {campo1 === "densidadeMedia" ? (
                    <TableCell colSpan={2} sx={celulaInputSx}>
                      {renderValorGrupo("densidade", campo1, editavel, index)}
                    </TableCell>
                  ) : (
                    <>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("densidade", campo1, editavel, index)}
                      </TableCell>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("densidade", campo2, editavel, index)}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        </fieldset>
        <fieldset disabled={!ensaioHabilitado("caracterizacao-massa-unitaria")} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: ensaioHabilitado("caracterizacao-massa-unitaria") ? 1 : 0.45 }}>
        {renderNormaReferencia("massaUnitaria")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 900, tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 42 }} />
              <col style={{ width: 300 }} />
              <col style={{ width: 120 }} />
              <col style={{ width: 145 }} />
              <col style={{ width: 145 }} />
            </colgroup>
            <TableBody>
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 700 }}>Data:</TableCell>
                <TableCell>
                  <TextField
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataMassaUnitaria || ""}
                    onChange={(e) => atualizarCampo("dataMassaUnitaria", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell align="left" sx={{ color: "#003f8f", fontWeight: 700 }}>
                  MASSA UNITÁRIA EM ESTADO SOLTO NBR 16972
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>OPERADOR:</TableCell>
                <TableCell>
                  <TextField
                    value={caracterizacao.operadorMassaUnitaria || ""}
                    onChange={(e) => atualizarCampo("operadorMassaUnitaria", e.target.value)}
                    size="small"
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>

              {massaUnitariaLinhas.map(([letra, descricao, formula, campo1, campo2, editavel], index) => (
                <TableRow key={`${letra}-${descricao}`}>
                  <TableCell align="center" sx={{ width: 42 }}>{letra}</TableCell>
                  <TableCell>{descricao}</TableCell>
                  <TableCell align="center">{formula}</TableCell>
                  {campo1 === "mediaMassaUnitaria" ? (
                    <TableCell colSpan={2} sx={celulaInputSx}>
                      {renderValorGrupo("massaUnitaria", campo1, editavel, index)}
                    </TableCell>
                  ) : (
                    <>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("massaUnitaria", campo1, editavel, index)}
                      </TableCell>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("massaUnitaria", campo2, editavel, index)}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        </fieldset>
        <Paper sx={{ p: 2, mb: 3 }}>
          <TextField
            label="Observações"
            value={caracterizacao.observacoes || ""}
            onChange={(e) => atualizarCampo("observacoes", e.target.value)}
            fullWidth
            multiline
            minRows={3}
          />
        </Paper>

        {(ensaioHabilitado("caracterizacao-torroes-argila") || ensaioHabilitado("caracterizacao-materiais-pulverulentos")) && renderTorroesPulverulentos()}
        {ensaioHabilitado("caracterizacao-impurezas-organicas") && renderNormaReferencia("impurezasOrganicas")}
        {ensaioHabilitado("caracterizacao-impurezas-organicas") && renderImpurezasOrganicas()}
        {ensaioHabilitado("caracterizacao-equivalente-areia") && renderEquivalenteAreia()}
        {ensaioHabilitado("caracterizacao-particulas-leves") && renderParticulasLeves()}
        {ensaioHabilitado("caracterizacao-sais-cloretos-sulfatos") && renderSaisCloretosSulfatos()}

      </Box>

      <Dialog open={normaDialog.open} onClose={fecharNormaReferencia} fullWidth maxWidth="sm">
        <DialogTitle>Editar norma de referência</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Norma de referência"
            value={normaDialog.valor}
            onChange={(event) =>
              setNormaDialog((prev) => ({
                ...prev,
                valor: event.target.value,
              }))
            }
            fullWidth
            multiline
            minRows={3}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharNormaReferencia} disabled={salvando}>Cancelar</Button>
          <Button variant="contained" onClick={salvarNormaReferencia} disabled={salvando}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
